import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { itemSelector: String }
  static targets = ['input']

  declare itemSelectorValue: string
  declare inputTarget: HTMLInputElement

  get items(): HTMLElement[] {
    return Array.from(this.element.querySelectorAll(this.itemSelectorValue))
  }

  filter(): void {
    const query = this.inputTarget.value.toLowerCase()
    this.items.forEach((item) => {
      item.style.display =
        query === '' || item.textContent!.toLowerCase().includes(query)
          ? ''
          : 'none'
    })
  }

  handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.inputTarget.value = ''
      this.filter()
    } else if (event.key === 'Enter') {
      const visible = this.items.filter((i) => i.style.display !== 'none')
      if (visible.length !== 1) return
      const link = visible[0].querySelector<HTMLAnchorElement>('a')
      if (link) link.click()
    }
  }
}
